import {html, LitElement} from "@isceco/widget-library2/external/lit";
import {getFomanticStylesheet} from '@isceco/widget-library2/assets/fomantic-icons-styles.js'
import '@isceco/widget-library2/basic-elements/Card/Card.js'
import TileCss from "./TileCss";

export default class Tile extends LitElement {

  static get properties() {
    return {
      text: {type: String},
      description: {type: String},
      icon: {type: String},
      count: {type: Number}
    }
  }

  static get styles() {
    return [TileCss]
  }

  connectedCallback() {
    super.connectedCallback()

    getFomanticStylesheet()
      .then(stylesheet => {
        this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, stylesheet]})
      .catch(error => {
        throw error
      })
  }

  constructor() {
    super()
    this.text = ''
    this.description = ''
    this.icon = ''
    this.count = null
  }

  render() {
    return html`
      <isceco-card class="tile-card">
        <div class="tile-wrapper">
          <div class="tile-text">
            <h3>${this.text}</h3>
            <p>${this.description}</p>
          </div>
          <div class="tile-content">
            <slot name="icon">
                <i class="huge ${this.icon}"></i>
            </slot>
            <div class="tile-count">${this.count}</div>
          </div>
        </div>
      </isceco-card>
    `
  }
}
customElements.define('eko-tile', Tile)
